export enum INSTANCE_ENUM {
  VUE,
  VUE_ROUTER
}
